import { render, staticRenderFns } from "./DocHub.vue?vue&type=template&id=54a83f84&"
import script from "./DocHub.vue?vue&type=script&lang=js&"
export * from "./DocHub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports